module.exports = __webpack_public_path__ + "img/background-contatti.e153a388.jpg";